import {
  Stack,
  // Button,
  Typography,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  SxProps,
  TableSortLabel,
  TableBody,
  TablePagination,
  Pagination,
  IconButton,
  Button,
} from "@mui/material";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import { useState, useMemo } from "react";
import PositiveST from "./PositiveST";
import NegeativeST from "./NegeativeST";
import AiRecomondationST from "./AiRecomondationST";
import SaveChangesAI from "./SaveChangesAI";
import { Theme } from "@emotion/react";
import { useSelector } from "react-redux";
import { useSTOAIRecommendations } from "../../../../../STOperationhooks/useSTOOperationAI";
import {
  resetAllDefinitions,
  setNegetiveSearchTerm,
  setPositiveSearchTerm,
} from "../../../../../../../../../features/aiRecomendationTabSlice";
import { useDispatch } from "react-redux";
import { setDisplayErrorSnackBar } from "../../../../../../../../../features/userSlice";

const FirstTableAi = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [openNegativeST, setOpenNegativeST] = useState(false);
  const [openAiRecomondationST, setOpenAiRecomondationST] = useState(false);
  const [OpensaveTerm, setOpensaveTerm] = useState(false);
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [sort, setSort] = useState<{
    keytoSort: string;
    direction: "asc" | "desc";
  }>({ keytoSort: "keyword_name", direction: "desc" });
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const {
    allAIRecomendation,
    selectedCampaigns,
    selectedAdgroups,
    selectedKeyword,
    allDefinitaions,
  } = useSelector((state: any) => state.aiRecomandationTab);
  const {
    fetchPositiveST,
    fetchNegetiveST,
    removeNegativeTermsAi,
    handleRemoveNegativeAPI, // Add this function in your hook
    handleIgnoreAPI,
    fetchAIRecommendationsWithoutLoader,
    getAllExactST,
  } = useSTOAIRecommendations();

  // First filter, then sort
  const filteredAndSortedData = useMemo(() => {
    if (
      !allAIRecomendation ||
      !Array.isArray(allAIRecomendation) ||
      allAIRecomendation.length === 0
    )
      return [];

    // Apply filters first
    const filtered = allAIRecomendation.filter((row: any) => {
      const campaignMatch =
        selectedCampaigns?.length > 0
          ? selectedCampaigns.includes(row.campaign_name)
          : true;

      const adgroupMatch =
        selectedAdgroups?.length > 0
          ? selectedAdgroups.includes(row.adgroup_name)
          : true;

      const searchMatch =
        selectedKeyword && typeof selectedKeyword === "string"
          ? row.keyword_name
              ?.toLowerCase()
              .includes(selectedKeyword?.toLowerCase())
          : true;

      return campaignMatch && adgroupMatch && searchMatch;
    });

    // Then apply sorting
    const sorted = [...filtered].sort((a: any, b: any) => {
      const aValue = a[sort.keytoSort];
      const bValue = b[sort.keytoSort];

      if (aValue === bValue) return 0;

      const comparison = aValue > bValue ? 1 : -1;
      return sort.direction === "asc" ? comparison : -comparison;
    });

    return sorted;
  }, [
    allAIRecomendation,
    sort,
    selectedCampaigns,
    selectedAdgroups,
    selectedKeyword,
  ]);

  const paginatedRows = useMemo(() => {
    const start = page * rowsPerPage;
    return filteredAndSortedData.slice(start, start + rowsPerPage);
  }, [filteredAndSortedData, page, rowsPerPage]);

  const handleHeaderClick = (header: any) => {
    if (!header.sortable) return;

    setSort((prev) => ({
      keytoSort: header.KEY,
      direction:
        prev.keytoSort === header.KEY && prev.direction === "asc"
          ? "desc"
          : "asc",
    }));
  };

  const handleChangePage = (_: any, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenDialog = (row: any) => {
    fetchPositiveST(row.keyword_shared_uid);
    setSelectedRow(row);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    dispatch(setPositiveSearchTerm([]));
    setSelectedRow(null);
    setOpenDialog(false);
  };

  const handleOpenNegativeST = (row: any) => {
    fetchNegetiveST(row.keyword_shared_uid);
    setSelectedRow(row);
    setOpenNegativeST(true);
  };

  const handleCloseNegativeST = () => {
    dispatch(setNegetiveSearchTerm([]));
    setSelectedRow(null);
    setOpenNegativeST(false);
  };

  const handleOpenAiRecomondationST = async (row: any) => {
    // Check if there are any existing definitions for this keyword
    // by checking if any key in allDefinitaions starts with this keyword's shared_uid
    const keywordPrefix = `${row.keyword_shared_uid}_`;
    const hasExistingDefinitions = Object.keys(allDefinitaions).some((key) =>
      key.startsWith(keywordPrefix)
    );

    // Only call API if there are no existing definitions for this keyword
    if (!hasExistingDefinitions) {
      setOpenAiRecomondationST(true);
      setSelectedRow(row);
      await removeNegativeTermsAi(row.keyword_shared_uid);
      getAllExactST(row.adgroup_shared_uid);
    }
    setOpenAiRecomondationST(true);
    setSelectedRow(row);
  };

  const handleCloseAiRecomondationST = () => {
    setSelectedRow(null);
    setOpenAiRecomondationST(false);
  };

  const handleOpenSaveTerm = (row: any) => {
    setSelectedRow(row);
    setOpensaveTerm(true);
  };

  const handleConfirmSaveChanges = async (
    removedSharedUids: string[],
    ignoredSharedUids: string[]
  ) => {
    try {
      const allPromises = [];

      // Create promises for all "mark-as-removed" API calls
      if (removedSharedUids.length > 0) {
        const removePromises = removedSharedUids.map(async (sharedUid) => {
          try {
            await handleRemoveNegativeAPI(sharedUid);
            return { success: true, type: "removed", id: sharedUid };
          } catch (error) {
            console.error(`Failed to remove ${sharedUid}:`, error);
            return { success: false, type: "removed", id: sharedUid, error };
          }
        });
        allPromises.push(...removePromises);
      }

      // Create promises for all "mark-as-ignored" API calls
      if (ignoredSharedUids.length > 0) {
        const ignorePromises = ignoredSharedUids.map(async (sharedUid) => {
          try {
            await handleIgnoreAPI(sharedUid);
            return { success: true, type: "ignored", id: sharedUid };
          } catch (error) {
            console.error(`Failed to ignore ${sharedUid}:`, error);
            return { success: false, type: "ignored", id: sharedUid, error };
          }
        });
        allPromises.push(...ignorePromises);
      }

      // Wait for all API calls to complete
      const results = await Promise.all(allPromises);

      // Analyze results
      const successCount = results.filter((r) => r.success).length;
      const failureCount = results.filter((r) => !r.success).length;
      const totalCount = results.length;

      // Show appropriate messages based on results
      if (failureCount === 0) {
        // All successful
        dispatch(
          setDisplayErrorSnackBar({
            message: `All ${totalCount} changes saved successfully!`,
            type: "success",
          })
        );

        // Clear all definitions after successful save
        dispatch(resetAllDefinitions());

        // Optionally refresh the main data table
        // await fetchAllAIRecommendations();
      } else if (successCount === 0) {
        // All failed
        dispatch(
          setDisplayErrorSnackBar({
            message: `Failed to save ${totalCount} changes. Please try again.`,
            type: "error",
          })
        );
      } else {
        // Partial success
        dispatch(
          setDisplayErrorSnackBar({
            message: `${successCount} of ${totalCount} changes saved successfully. ${failureCount} failed.`,
            type: "warning",
          })
        );

        // Optionally: Clear only successful definitions
        // You could implement selective clearing based on successful IDs
      }
    } catch (error) {
      console.error("Unexpected error in handleConfirmSaveChanges:", error);
      dispatch(
        setDisplayErrorSnackBar({
          message: "An unexpected error occurred. Please try again.",
          type: "error",
        })
      );
    } finally {
      dispatch(resetAllDefinitions());
      fetchAIRecommendationsWithoutLoader();
    }
  };

  const handleCloseSaveTerm = () => {
    setSelectedRow(null);
    setOpensaveTerm(false);
  };

  // Define columns
  const tableHeaders = [
    { id: 1, KEY: "keyword_name", label: "Keyword Name", sortable: true },
    {
      id: 2,
      KEY: "keyword_match_type",
      label: "Keyword Match Type",
      sortable: true,
    },
    { id: 3, KEY: "adgroup_name", label: "Adgroup Name", sortable: true },
    { id: 4, KEY: "campaign_name", label: "Campaign Name", sortable: true },
    {
      id: 5,
      KEY: "impression_last_30_days",
      label: "Impressions",
      sortable: true,
    },
    { id: 6, KEY: "clicks_last_30_days", label: "Clicks", sortable: true },
    { id: 7, KEY: "cost_last_30_days", label: "Cost", sortable: true },
    {
      id: 8,
      KEY: "conversions_last_30_days",
      label: "Conversions",
      sortable: true,
    },
    { id: 9, KEY: "positive_st_amount", label: "Positive ST", sortable: true },
    { id: 10, KEY: "negative_st_amount", label: "Negative ST", sortable: true },
    {
      id: 11,
      KEY: "ai_action",
      label: "AI Rec",
      sortable: false,
      type: "custom",
    },
  ];

  return (
    <>
      <Stack flexDirection={"column"} alignItems={"flex-end"} gap={2}>
        <TableContainer
          component={Paper}
          sx={{
            boxShadow: "none",
            mt: 2,
          }}
        >
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                {tableHeaders.map((header: any) => {
                  const isLeftSticky = header.id === 1 || header.id === 2;
                  const isRightSticky =
                    header.id === tableHeaders[tableHeaders.length - 1].id;

                  const leftOffsets: Record<number, number> = {
                    1: 0,
                    2: 150,
                  };

                  const cellSx = isLeftSticky
                    ? ({
                        position: "sticky",
                        left: leftOffsets[header.id] ?? 0,
                        zIndex: 10,
                        backgroundColor: "background.paper",
                        borderRight:
                          header.id === 2 ? "1px solid #e0e0e0" : undefined,
                      } as SxProps<Theme>)
                    : isRightSticky
                    ? ({
                        position: "sticky",
                        right: 0,
                        zIndex: 9,
                        backgroundColor: "background.paper",
                        borderLeft: "1px solid #e0e0e0",
                      } as SxProps<Theme>)
                    : ({} as SxProps<Theme>);

                  return (
                    <TableCell key={header.id} align="left" sx={cellSx}>
                      <TableSortLabel
                        active={sort.keytoSort === header.KEY}
                        direction={
                          sort.keytoSort === header.KEY ? sort.direction : "asc"
                        }
                        onClick={() => handleHeaderClick(header)}
                        disabled={!header.sortable}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        {header.label}
                      </TableSortLabel>
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>

            <TableBody>
              {paginatedRows.length > 0 ? (
                paginatedRows.map((row: any) => {
                  return (
                    <TableRow key={row.keyword_id}>
                      <TableCell
                        sx={{
                          position: "sticky",
                          left: 0,
                          zIndex: 1,
                          whiteSpace: "normal",
                          overflowWrap: "break-word",
                          wordBreak: "break-word",
                          backgroundColor: "background.paper",
                        }}
                      >
                        {row.keyword_name ?? ""}
                      </TableCell>
                      <TableCell
                        sx={{
                          position: "sticky",
                          left: 150,
                          zIndex: 1,
                          whiteSpace: "normal",
                          overflowWrap: "break-word",
                          wordBreak: "break-word",
                          backgroundColor: "background.paper",
                          borderRight: "1px solid #e0e0e0",
                        }}
                      >
                        {row.keyword_match_type ?? ""}
                      </TableCell>
                      <TableCell>{row.adgroup_name ?? ""}</TableCell>
                      <TableCell>{row.campaign_name ?? ""}</TableCell>
                      <TableCell>
                        {row.impression_last_30_days?.toLocaleString() ?? 0}
                      </TableCell>
                      <TableCell>
                        {row.clicks_last_30_days?.toLocaleString() ?? 0}
                      </TableCell>
                      <TableCell>
                        {row.cost_last_30_days?.toFixed(2) ?? "0.00"}$
                      </TableCell>
                      <TableCell>
                        {Math.round(Number(row.conversions_last_30_days ?? 0))}%
                      </TableCell>
                      <TableCell>
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: "0.99rem",
                            fontWeight: 500,
                            color:
                              row.positive_st_amount > 0 ? "green" : "default",
                            cursor:
                              row.positive_st_amount > 0
                                ? "pointer"
                                : "default",
                            textDecoration:
                              row.positive_st_amount > 0 ? "underline" : "none",
                            "&:hover": {
                              textDecoration:
                                row.positive_st_amount > 0
                                  ? "underline"
                                  : "none",
                            },
                          }}
                          onClick={() => {
                            if (row.positive_st_amount > 0) {
                              handleOpenDialog(row);
                            }
                          }}
                          data-tracker="607"
                        >
                          {row.positive_st_amount ?? 0}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: "0.99rem",
                            fontWeight: 500,
                            color:
                              row.negative_st_amount > 0 ? "red" : "default",
                            cursor:
                              row.negative_st_amount > 0
                                ? "pointer"
                                : "default",
                            textDecoration:
                              row.negative_st_amount > 0 ? "underline" : "none",
                            "&:hover": {
                              textDecoration:
                                row.negative_st_amount > 0
                                  ? "underline"
                                  : "none",
                            },
                          }}
                          onClick={() => {
                            if (row.negative_st_amount > 0) {
                              handleOpenNegativeST(row);
                            }
                          }}
                          data-tracker="608"
                        >
                          {row.negative_st_amount ?? 0}
                        </Typography>
                      </TableCell>
                      <TableCell
                        sx={{
                          position: "sticky",
                          right: 0,
                          zIndex: 2,
                          backgroundColor: "background.paper",
                          borderLeft: "1px solid #e0e0e0",
                        }}
                      >
                        <IconButton
                          color="secondary"
                          size="small"
                          onClick={() => {
                            handleOpenAiRecomondationST(row);
                          }}
                          sx={{
                            "&:hover": {
                              backgroundColor: "rgba(156, 39, 176, 0.1)",
                            },
                          }}
                        >
                          <AutoFixHighIcon
                            fontSize="small"
                            data-tracker="609"
                          />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={tableHeaders.length} align="center">
                    No data available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>

      <Stack
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
        mt={2}
        mb={2}
      >
        <Button
          variant="contained"
          color="secondary"
          endIcon={<SaveOutlinedIcon />}
          onClick={handleOpenSaveTerm}
          sx={{ ml: 2 }}
          disabled={Object.keys(allDefinitaions).length === 0}
          data-tracker="611"
        >
          Save changes
        </Button>
      </Stack>
      {paginatedRows.length > 0 && (
        <Stack
          spacing={1}
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ p: 1 }}
        >
          <TablePagination
            rowsPerPageOptions={[]}
            component="div"
            count={filteredAndSortedData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{
              ".MuiInputBase-root-MuiTablePagination-select,.MuiTablePagination-selectLabel":
                {
                  display: "none",
                },
              ".MuiTablePagination-actions": { display: "none" },
              ".MuiTablePagination-toolbar": { paddingLeft: "16px" },
            }}
          />

          <Pagination
            count={Math.ceil(filteredAndSortedData.length / rowsPerPage)}
            onChange={(_, value) => handleChangePage(null, value - 1)}
            page={page + 1}
            showFirstButton
            showLastButton
            color="secondary"
            size="small"
          />

          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={filteredAndSortedData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            classes={{
              displayedRows: "hidden-displayed-rows",
            }}
            sx={{
              ".MuiTablePagination-actions": { display: "none" },
              ".MuiTablePagination-input": { marginRight: "15px" },
            }}
          />
        </Stack>
      )}

      <PositiveST
        open={openDialog}
        rowData={selectedRow}
        onClose={handleCloseDialog}
      />

      <NegeativeST
        open={openNegativeST}
        rowData={selectedRow}
        onClose={handleCloseNegativeST}
      />

      <AiRecomondationST
        open={openAiRecomondationST}
        rowData={selectedRow}
        onClose={handleCloseAiRecomondationST}
      />

      <SaveChangesAI
        open={OpensaveTerm}
        rowData={selectedRow}
        onClose={handleCloseSaveTerm}
        onConfirm={handleConfirmSaveChanges}
      />
    </>
  );
};

export default FirstTableAi;
